import dayjs from "dayjs";
import React, { Dispatch, SetStateAction, useState } from "react";
import { LineBoxContainer } from "../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../Button/CalendarLineBtn";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import Flex from "../../../DefaultStyles/Flex";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import CalendarModal from "../../../Modal/CalendarModal";
import ToolTip from "../../../Modal/ToolTip";
import { SectionFilterContainer } from "../../AlimTalk/AlimTalkFilter";

interface AlimTalkFailFilterProps {
  filter: {
    date: string;
    isSuccess: string;
  };
  setFilter: Dispatch<SetStateAction<{ date: string; isSuccess: string }>>;
}

export default function AlimTalkFailFilter({
  setFilter,
}: AlimTalkFailFilterProps) {
  const [date, setDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [dateClick, setDateClick] = useState(false);
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });

  const options: OptionType[] = [
    { value: "1", label: "알림톡 실패" },
    { value: "2", label: "알림톡 실패, 문자 발송중" },
    { value: "0", label: "알림톡, 문자 모두 실패" },
  ];

  return (
    <SectionFilterContainer>
      <SpaceBetween>
        <div></div>

        <Flex gapSize={10}>
          <DropDown
            setDropDownValue={setDropDownValue}
            dropdownValue={dropDownValue}
            boxWidth={190}
            optionList={options}
          />

          <ToolTip direction="top" msg="하루치 실패 내역만 조회 가능" />

          <LineBoxContainer>
            <CalendarLineBtn
              onClickEvent={() => setDateClick(true)}
              value={date}
              initValue={"날짜 선택"}
              minWidth={155}
            />

            {dateClick && (
              <CalendarModal
                closeEvent={() => setDateClick(false)}
                changeEvent={(date: string) => setDate(date)}
                isFutureDisable={true}
              />
            )}
          </LineBoxContainer>

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            btnClickEvent={() => {
              setFilter({
                isSuccess: dropDownValue?.value!,
                date,
              });
            }}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            btnClickEvent={() => {
              setDate(dayjs().format("YYYY-MM-DD"));

              setDropDownValue({
                value: "",
                label: "선택",
              });
              setFilter({
                isSuccess: "",
                date: dayjs().format("YYYY-MM-DD"),
              });
            }}
          />
        </Flex>
      </SpaceBetween>
    </SectionFilterContainer>
  );
}
